// this file is generated by update_shopify_store_data.py at 2026-06-22 20:23:31.104317
var courses = [
    {
        "course_id": "A10861B2-2BB0-F011-99A4-005056A725AD",
        "course_version": 1,
        "name": "Pneumothorax and Chest Tubes Explained Clearly",
        "course_type": 1,
        "author_information": "Roger Seheult, MD",
        "description": "Manage pneumothoraxes and chest tubes with confidence. In this clear, concise course, Roger Seheult, MD\u2014renowned educator and critical care specialist\u2014breaks down the key steps of pneumothorax diagnosis, imaging, and treatment, along with chest tube placement and management.\r\n\r\n\r\nThrough engaging video lectures, clinical examples, and quick quizzes, you\u2019ll gain practical insights that bridge theory and real-world application\u2014essential for clinicians in emergency medicine, critical care, and hospital settings.\r\n\r\n\r\nWhat You\u2019ll Learn\r\n-A clear, systematic approach to diagnosing and managing pneumothoraxes\r\n-How to differentiate between spontaneous and non-spontaneous pneumothoraxes\r\n-How to utilize imaging effectively, including recognizing lung sliding on ultrasound\r\n-Step-by-step guidance for placing and managing chest tubes\r\n-How to use and troubleshoot a three-container suction chest tube system\r\n-Practical pearls and case-based reinforcement to solidify learning\r\n-Trusted by universities, clinicians, and students worldwide, this course transforms complexity into clarity\u2014helping you deliver safe, effective care when it matters most.\r\n\r\n\r\nIncludes 2.75 CME (Category 1), MOC Points, and CE Credits.",
        "learning_objectives_html": "<div class=\"objectives-container\">\r\n<p>Upon completion of this continuing medical education activity, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the criteria for observation of primary and secondary spontaneous pneumothoraces without a chest tube.</li>\r\n    <li>Recognize lung sliding and no lung sliding on an ultrasound.</li>\r\n    <li>Utilize a 3-container suction chest tube system and describe the difference between an air leak and suction being applied to the system.</li>\r\n</ul>\r\n</div>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                "course_category_name": "Course",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CBF0E856-7B98-F011-999F-005056A70840",
                "course_category_name": "Medcram",
                "is_system_course_category": null
            },
            {
                "course_category_id": "58382785-93D1-E511-BF53-005056B122EA",
                "course_category_name": "Respiratory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A2D99439-7B98-F011-999F-005056A70840",
                "course_category_name": "Medcram",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AFB1D1BB-7B98-F011-999F-005056A70840",
                "course_category_name": "Medcram",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5A34B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Respiratory Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5A8D6672-C8AA-F011-999E-005056A78EAA",
                "course_category_name": "MedCram",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CE - Continuing Education",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ACCME",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "AMA PRA Category 1 Credits&trade;:&nbsp;Continuing Education Company, Inc. (CEC) is\r\naccredited by the Accreditation Council for Continuing Medical Education (ACCME) to\r\nprovide continuing medical education for physicians.\r\n<br />\r\n<br />\r\nContinuing Education Company, Inc. designates this enduring material for a maximum of\r\n2.75 AMA PRA Category 1 Credits&trade;. <br />\r\n<br />\r\nPhysicians should claim only the credit\r\ncommensurate with the extent of their participation in the activity.",
            "credit_display_name": "CME",
            "credit_units": 2.75,
            "credit_unit_display_name": "<em>AMA PRA Category I Credit(s)&trade;</em>"
        },
        "sub_courses": []
    }
];